import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rate-container flex-center" }
const _hoisted_2 = { class: "rate-title" }
const _hoisted_3 = { class: "input-pay-container flex-center" }
const _hoisted_4 = { class: "rate flex-center" }
const _hoisted_5 = { class: "rate-info" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "amount" }, "$", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "blank" }, "___", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "rate-subtitle" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "minutes flex-center" }
const _hoisted_10 = { class: "minutes-info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "for", -1 /* HOISTED */)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "timeUnit" }, "Min", -1 /* HOISTED */)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "minutes-subtitle" }, null, -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "earnings-container flex-center"
}
const _hoisted_15 = { class: "earnings-total" }
const _hoisted_16 = { class: "earnings-info" }
const _hoisted_17 = { class: "earnings-rate" }
const _hoisted_18 = { class: "earnings-trans" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString($setup.prompt), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            class: "paymentAmount",
            type: "number",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.amount) = $event)),
            onChange: $setup.changeAmount
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelText, $setup.amount]
          ]),
          _hoisted_7
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            class: "timeAmount",
            type: "number",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.minutes) = $event)),
            min: "30",
            onChange: $setup.changeTime
          }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
            [_vModelText, $setup.minutes]
          ]),
          _hoisted_12
        ]),
        _hoisted_13
      ])
    ]),
    (!$props.invite.payer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, "Total Earnings: $" + _toDisplayString($setup.total), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, "Rate: $" + _toDisplayString($setup.props.amount), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_18, " Transaction Fee: $" + _toDisplayString($setup.fee.toFixed(2)), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}